/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountCredentialsForAnthropicPlatform extends models.ServiceAccountCredentialsBaseForAiPlatform {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountCredentialsForAnthropicPlatform");
    }

    getFixupPrototypeFunction() { return ServiceAccountCredentialsForAnthropicPlatform.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountCredentialsForAnthropicPlatform>): ServiceAccountCredentialsForAnthropicPlatform {
        let obj = Object.assign(new ServiceAccountCredentialsForAnthropicPlatform(), model);
        ServiceAccountCredentialsForAnthropicPlatform.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountCredentialsForAnthropicPlatform>): ServiceAccountCredentialsForAnthropicPlatform {
        if (!model) return null;
        return ServiceAccountCredentialsForAnthropicPlatform.newInstance(<ServiceAccountCredentialsForAnthropicPlatform> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountCredentialsForAnthropicPlatform) {
        if (!obj) return;

        models.ServiceAccountCredentialsForAnthropicPlatform.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountCredentialsForAnthropicPlatform): boolean {
        if (models.ServiceAccountCredentialsBaseForAiPlatform.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountCredentialsForAnthropicPlatform.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Anthropic Admin API key
     */
    admin_key: string;

}
